import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
// Grab from Vanadium/src/api/account/manual-account/[accountId]/20240627.ts
export const ManualAccountStatusList = ["Active", "Sold"];
const ManualAccountStatus = z.enum(ManualAccountStatusList);
export const ManualAccountTypeList = [
    "Real Estate",
    "Private Investment Holding",
    "Crypto",
    "Collectable",
];
export const ManualAccountType = z.enum(ManualAccountTypeList);
export const ManualAccountDetails = z.object({
    account: z.object({
        id: z.string().describe("Manual Account Id"),
        name: z.string().describe("Client created name of the account"),
        status: ManualAccountStatus.describe("Status of the account"),
        type: ManualAccountType.describe("Type of the account"),
        ownerId: z.string().describe("Person Id of the owner of the account"),
        lastValue: z.number().describe("Current value of the asset"),
        createdAt: z.string().datetime().describe("Time the account was created"),
        updatedAt: z.string().datetime().describe("Time the account was updated"),
    }),
    values: z
        .object({
        createdAt: z.string().datetime().describe("Time the price was recorded"),
        value: z.number().describe("Price of the asset at the time"),
    })
        .array(),
});
export const getManualAccountUrl = (manualAccountId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/account/manual-account/${manualAccountId}`
    : `https://middleware.uat.farther.com/account/manual-account/${manualAccountId}`;
export default async function getManualAccountsVanadium(accountId, config) {
    const { data } = await axios.get(getManualAccountUrl(accountId), {
        headers: {
            Version: "20240627",
            Authorization: `Bearer ${config.jwt}`,
            ...("advisorId" in config && { Advisor: config.advisorId }),
            ...("clientId" in config && { Client: config.clientId }),
        },
    });
    const decoded = ManualAccountDetails.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = `${getManualAccountsVanadium.name} Could not parse`;
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getManualAccountDetailVanadium.js.map